const t = {
  name: "RestrictedFill",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 11V9H13C13.5477 9 14 9.45228 14 10C14 10.5477 13.5477 11 13 11H10Z" fill="currentColor"/>
<path d="M1 12C1 5.92772 5.92772 1 12 1C18.0723 1 23 5.92772 23 12C23 18.0723 18.0723 23 12 23C5.92772 23 1 18.0723 1 12ZM16 10C16 8.34772 14.6523 7 13 7H8V17H10V13C12.2077 13 14 14.7923 14 17H16C16 15.3341 15.3201 13.8262 14.2228 12.7387C15.2686 12.2691 16 11.2172 16 10Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as RestrictedFill
};
